import api from './api';

// Service du module « Google Ads ».
const adsApi = {
  // Comptes Google Ads accessibles (groupés par manager / MCC).
  getAccounts: () => api.get('/google-ads/accounts'),
  // Configuration (super-admin) : mapping compte → concession (gestion des droits).
  getConfig: () => api.get('/google-ads/config'),
  setAccountConcession: (customerId, concession_id) => api.patch(`/google-ads/accounts/${customerId}`, { concession_id }),

  // Rapport complet pour un compte + période. compare = comparaison vs période précédente.
  getReport: ({ customer, start, end, compare }) =>
    api.get('/google-ads/report', {
      params: { customer, start, end, compare: compare ? 1 : 0 },
    }),

  // KPIs consolidés de tous les comptes gérés.
  getOverview: ({ start, end }) =>
    api.get('/google-ads/overview', { params: { start, end } }),

  // Audit IA de la configuration d'un compte.
  getAudit: (customer) => api.get('/google-ads/audit', { params: { customer } }),
  runAudit: (customer) => api.post('/google-ads/audit', { customer }),

  // Pilote auto (suggestion + validation).
  getAutopilotConfig: (customer) => api.get('/google-ads/autopilot/config', { params: { customer } }),
  saveAutopilotConfig: (data) => api.put('/google-ads/autopilot/config', data),
  generateActions: (customer) => api.post('/google-ads/autopilot/generate', { customer }),
  getActions: (customer, status) => api.get('/google-ads/autopilot/actions', { params: { customer, status } }),
  applyAction: (id) => api.post(`/google-ads/autopilot/actions/${id}/apply`),
  rejectAction: (id) => api.post(`/google-ads/autopilot/actions/${id}/reject`),
  revertAction: (id) => api.post(`/google-ads/autopilot/actions/${id}/revert`),

  // Pilote AUTONOME (mode 'auto' à fenêtre de veto).
  triggerRun: (customer, dry_run = false) => api.post('/google-ads/autopilot/run', { customer, dry_run }),
  executeNow: (customer) => api.post('/google-ads/autopilot/execute-now', { customer }),
  getRuns: (customer) => api.get('/google-ads/autopilot/runs', { params: { customer } }),
  getScheduled: (customer) => api.get('/google-ads/autopilot/scheduled', { params: { customer } }),
  veto: (id) => api.post(`/google-ads/autopilot/veto/${id}`),
  vetoAll: (customer) => api.post('/google-ads/autopilot/veto-all', { customer }),
  rollbackRun: (runId) => api.post(`/google-ads/autopilot/rollback-run/${runId}`),
  rollbackAllAuto: (customer) => api.post('/google-ads/autopilot/rollback-all', { customer }),

  // Création SEA (assistant Claude + brouillon + création validée).
  seaListDrafts: (customer) => api.get('/google-ads/sea/drafts', { params: { customer } }),
  seaCreateDraft: (customer, title) => api.post('/google-ads/sea/drafts', { customer, title }),
  seaGetDraft: (id) => api.get(`/google-ads/sea/drafts/${id}`),
  seaDeleteDraft: (id) => api.delete(`/google-ads/sea/drafts/${id}`),
  seaBuild: (id) => api.post(`/google-ads/sea/drafts/${id}/build`),
  seaRevert: (id) => api.post(`/google-ads/sea/drafts/${id}/revert`),
};

export default adsApi;
